module.exports = __webpack_public_path__ + "static/media/COMP-102-badge.1cda7890.svg";